// Uses uuid/v4 for all IDs (existing pattern from createTask.js)
export default {
  // Full page records from API, indexed by record.id (MongoDB _id)
  // Shape: { id, name, pid, page: {...}, created_at, updated_at }
  recordsById: {},

  // All pages indexed by pageId (record.page.id)
  // Shape: { id, recordId, streamShell, meta, created_at, updated_at }
  // recordId links back to the API record for saving
  // streamShell: true until loadRecordPage hydrates persisted nodes
  pagesById: {},

  // Active page being rendered (uses pageId, not recordId)
  activePageId: null,

  // Normalized nodes across all pages
  // Key: nodeId (UUID), Value: { id, pageId, parentId, nodeType, props, layout, height, afterId, draggable, droppable }
  nodesById: {},

  // Parent-to-children mapping for efficient tree traversal
  // Key: parentId (UUID or 'root_${pageId}'), Value: [childId, childId, ...]
  childrenByParent: {},

  // Registered custom components
  // Key: nodeType string, Value: Vue component
  registeredComponents: {},

  // Pending updates for batching (flushed per animation frame)
  updateQueue: [],

  // Ghost template catalog keyed by section slug. Not page documents.
  templatesBySection: {},

  // True only after fetchRecords succeeds. A single fetchRecord (modal)
  // must not count as the journey catalog.
  treeLoaded: false,

  // Team that recordsById currently belongs to. Stale fetches whose team
  // or token does not match are ignored by setRecords.
  catalogTeamId: null,
  catalogToken: 0,
  pendingCatalogTeamId: null,

  // Loading/dirty states
  loading: false,
  saving: false,
};
